/**
 * @generated SignedSource<<01978a528f181b1af3b865f3679ca4b9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProductizedServiceType = "BUY_NOW_INSTANT_PURCHASE" | "BUY_NOW_OTHER" | "BUY_NOW_REQUEST" | "NOT_PURCHASABLE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ProductizedServiceCTAs_productizedService$data = {
  readonly id: string;
  readonly productizedServiceType: ProductizedServiceType | null;
  readonly slug: string;
  readonly userProfile: {
    readonly id: string;
  };
  readonly visitorCanEdit: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"ServiceInquiryButton_productizedService" | "useProductizedServicePreview_productizedService">;
  readonly " $fragmentType": "ProductizedServiceCTAs_productizedService";
};
export type ProductizedServiceCTAs_productizedService$key = {
  readonly " $data"?: ProductizedServiceCTAs_productizedService$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductizedServiceCTAs_productizedService">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductizedServiceCTAs_productizedService",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "productizedServiceType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserProfile",
      "kind": "LinkedField",
      "name": "userProfile",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ServiceInquiryButton_productizedService"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useProductizedServicePreview_productizedService"
    }
  ],
  "type": "ProductizedService",
  "abstractKey": null
};
})();

(node as any).hash = "f4fdde9b04ae9f6538b25dbe8e18a472";

export default node;
